export default __webpack_public_path__ + "static/media/330_business06-it-mobile.68460c28.png";